import {sendAuditReport as sendAuditReportApi} from '../../../services/report/report'

export async function sendAuditReport(data) {
  try {
    await sendAuditReportApi(data)
    // console.log(response)
    return 'success'
  } catch (e) {
    console.log(`Post Audit Report: ${data}`)
    // return e.response
    return 'error'
  }
}
